import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const ReasonContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.xl')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.75')};
`;
